'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { type FeaturedMosaicItemBlock } from '@module/mdrt-org/shared/utils/data/graphql/_generated/gql-generated';
import { FeaturedMosaicItem } from '../item/featured-mosaic-item';
import styles from '../../featured-mosaic-container-block.module.scss';
export type FeaturedMosaicSlideshowProps = {
  blockData: FeaturedMosaicItemBlock[];
};
export const FeaturedMosaicSlideshow = t0 => {
  const $ = _c(21);
  const {
    blockData
  } = t0;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const trackRef = useRef(null);
  const timerRef = useRef(null);
  const numberOfItems = blockData.length;
  const goToSlide = index => {
    const track = trackRef.current;
    if (!track) {
      return;
    }
    setCurrentIndex(index);
    track.scrollTo({
      behavior: "smooth",
      left: index * track.clientWidth
    });
  };
  let t1;
  if ($[0] !== isPaused || $[1] !== numberOfItems) {
    t1 = [isPaused, numberOfItems];
    $[0] = isPaused;
    $[1] = numberOfItems;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(() => {
    if (numberOfItems <= 1 || isPaused) {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      return;
    }
    timerRef.current = setInterval(() => {
      setCurrentIndex(previousIndex => {
        const nextIndex = (previousIndex + 1) % numberOfItems;
        const track_0 = trackRef.current;
        if (track_0) {
          track_0.scrollTo({
            behavior: "smooth",
            left: nextIndex * track_0.clientWidth
          });
        }
        return nextIndex;
      });
    }, 5000);
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, t1);
  const onSlideshowScroll = () => {
    const track_1 = trackRef.current;
    if (!track_1) {
      return;
    }
    const nextIndex_0 = Math.round(track_1.scrollLeft / track_1.clientWidth);
    if (nextIndex_0 !== currentIndex) {
      setCurrentIndex(nextIndex_0);
    }
  };
  const t2 = styles["featured-mosaic-slideshow"];
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsPaused(true);
    t4 = () => setIsPaused(false);
    t5 = () => setIsPaused(false);
    t6 = () => setIsPaused(true);
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== blockData) {
    t7 = blockData.map(_temp);
    $[7] = blockData;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== onSlideshowScroll || $[10] !== t7 || $[11] !== trackRef) {
    t8 = <div className={styles["featured-mosaic-slideshow-inner"]} onScroll={onSlideshowScroll} ref={trackRef}>{t7}</div>;
    $[9] = onSlideshowScroll;
    $[10] = t7;
    $[11] = trackRef;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = numberOfItems > 1 && <div className={styles["mosaic-slideshow-indicator"]}>{blockData.map((item_0, index_0) => <button aria-label={`Go to slide ${index_0 + 1}`} className={`${styles["mosaic-slideshow-indicator__dot"]} ${index_0 === currentIndex ? styles.active : ""}`} key={`dot-${item_0.ContentLink?.Id}`} onClick={() => goToSlide(index_0)} />)}</div>;
  let t10;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className={t2} onMouseEnter={t3} onMouseLeave={t4} onTouchEnd={t5} onTouchStart={t6}>{t8}{t9}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
function _temp(item) {
  return <FeaturedMosaicItem blockData={item} key={item.ContentLink?.Id} />;
}